export abstract class TimetableDay {
  date!: string;
  label!: string;
  weekDay!: number;
  current!: boolean;
}

export abstract class CalendarDay {
  label!: string;
  weekStart!: string;
  date!: string;
  current!: boolean;
  outsideCurrentMonth!: boolean;
}

export const SELECTED_DAY_FORMAT = 'yyyy-MM-dd' as const;

export const WEEK_START_FORMAT = 'yyyy-MM-dd' as const;

export const MONTH_START_FORMAT = 'yyyy-MM-dd' as const;

//TODO this is brittle and will break next year
export const ACADEMIC_YEAR_START_DATE = '2023-09-11' as const;

export const ACADEMIC_YEAR_SWITCHOVER_DATE = {
  day: 7,
  month: 8, // Jan = 1
} as const;
